import { render } from "./AppMenu.vue?vue&type=template&id=cfc17108"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=cfc17108&lang=scss"

import exportComponent from "C:\\Users\\info\\OneDrive\\Desktop\\REPO_MARTECH\\rcstudio-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__